import { gzipSync } from 'browserify-zlib';
import mapKey from "../../controllers/LessonPlanController/mapKey";

export function compress(activity_state) {
	if (!activity_state) return null;

	const activitySCORM = JSON.parse(JSON.stringify(activity_state));
	const sim = JSON.stringify(activitySCORM, simplify);
	const bufferCompressed = gzipSync(sim);
	const scorm_suspend_data = bufferCompressed.toString('base64');
	return scorm_suspend_data;
}

function simplify(k, v) {
	if (v && typeof v === 'object') {
		Object.entries(mapKey).forEach(entry => {
			if (entry[0] in v) {
				updateKey(v, entry[0], entry[1]);
			}
		});
	}
	if (k === 'c' || k === 'C' || k === 'S') {
		return v === true ? 1 : v === false ? 0 : v;
	}
	return v;
}

function updateKey(object, oldKey, newKey) {
	delete Object.assign(object, { [newKey]: object[oldKey] })[oldKey];
}